<table mat-table [dataSource]="tasks" class="{{!showListBorders?'mat-elevation-z0':'mat-elevation-z16'}}"
    multiTemplateDataRows style="width: 100%">
    <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef>Create Date</th>
        <td mat-cell *matCellDef="let task">
            {{task.createdAt}}
        </td>
    </ng-container>
    <ng-container matColumnDef="instanceName">
        <th mat-header-cell *matHeaderCellDef>Instance</th>
        <td mat-cell *matCellDef="let task">
            {{getInstanceName(task)}}
        </td>
    </ng-container>
    <ng-container matColumnDef="zoningCodeName">
        <th mat-header-cell *matHeaderCellDef>Zoning Code</th>
        <td mat-cell *matCellDef="let task">
            {{getZoningCodeName(task)}}
        </td>
    </ng-container>
    <ng-container matColumnDef="{{column.property}}" *ngFor="let column of taskColumns">
        <th mat-header-cell *matHeaderCellDef> {{column.title || column.getTitle()}} </th>
        <td mat-cell *matCellDef="let task"> {{task[column.property]}} </td>
    </ng-container>

    <ng-container matColumnDef="iterationsPerHour">
        <th mat-header-cell *matHeaderCellDef>Performance per hour</th>
        <td mat-cell *matCellDef="let task">
            {{task.iterationsPerHour | number : '.2-2'}}
        </td>
    </ng-container>

    <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let task">
            {{task.statusStr}}
        </td>
    </ng-container>

    <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let task" class="actions-container">
            <app-task-view [task]="task" [showCheckStatus]="true" [showRecalculateButton]="showRecalculateButton"
                [showStatus]="false" [showReindexButton]="true" [showTaskTabButton]="false" [showTaskTabButton]="true"
                [showProcessDetailsPopupButton]="showProcessDetailsPopupButton"
                [showClearThreadsButton]="showClearThreadsButton" [showStartStopButton]="showStartStopButton">
            </app-task-view>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="taskColumnsToDisplay; sticky: true"></tr>
    <tr mat-row *matRowDef="let task; columns: taskColumnsToDisplay;" class="task-element-row"></tr>

</table>